module.exports = __webpack_public_path__ + "static/promena-177ad709ac2bf277479b43dfb3fef10c.png";